// extracted by mini-css-extract-plugin
export default {"root":"Table_root__MkjDP","table":"Table_table__S31gr"};